{
    "Number": "Nee",
    "Starttime": "Begin",
    "From": "Van",
    "To": "Tot",
    "Duration": "Looptijd",
    "NAME": "CallRecording"
}